import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { FaSignature } from 'react-icons/fa';
import './signature.css'; // si tienes estilos opcionales

const AutorizacionFirma = ({ form, setForm, sigPadRef }) => {
  const clear = () => {
    if (sigPadRef?.current) {
      sigPadRef.current.clear();
    }
  };


  return (
    <div className="card card-app mb-4">
      <div className="card-header-app"><FaSignature /> AUTORIZACIÓN Y FIRMA</div>
      <div className="card-body">
        {/* Checkboxes */}
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={form.presupuesto}
                onChange={(e) => setForm(prev => ({ ...prev, presupuesto: e.target.checked }))}
              />
            }
            label="Solicito presupuesto previo antes de autorizar el trabajo"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={form.autoriza_reparacion}
                onChange={(e) => setForm(prev => ({ ...prev, autoriza_reparacion: e.target.checked }))}
              />
            }
            label="Autorizo realizar reparación sin presupuesto previo"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={form.autoriza_prueba}
                onChange={(e) => setForm(prev => ({ ...prev, autoriza_prueba: e.target.checked }))}
              />
            }
            label="Autorizo para conducir mi vehículo para pruebas"
          />
        </Box>

        {/* Firma */}
        <Typography variant="body2" sx={{ fontWeight: 600, color: '#083a94', mb: 1 }}>
          Firma del cliente
        </Typography>
        <Box
          sx={{
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            width: '100%',
            height: 200,
            mb: 2,
          }}
        >
          <SignatureCanvas
            ref={sigPadRef}
            canvasProps={{ className: 'signature-canvas' }}
          />
        </Box>

        <Button variant="contained" color="warning" size="small" onClick={clear}>
          Limpiar firma
        </Button>

        {/* Vista previa opcional */}
        {form.firma && (
          <Box sx={{ mt: 3 }}>
            <Typography sx={{ fontWeight: 'bold' }}>Firma guardada:</Typography>
            <img src={form.firma} alt="Firma" style={{ maxWidth: 300 }} />
          </Box>
        )}
      </div>
    </div>
  );
};

export default AutorizacionFirma;
